import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'tab', 'panel', 'dropdown', 'dropdownItem', 'dropdownSelected' ]

  connect() {
    this.activeClass = 'active'
    this.hiddenClass = 'hidden'
    this.index = this.data.get('index') || 0
    this.isScrollable = this.data.get('scrollable') || false
    this.isScrollToTabs = this.data.get('scrollToTabs') || false
    this.showTab()
  }

  changeTab(e) {
    e.preventDefault()

    this.index = e.currentTarget.dataset.index
    this.isScrollable = e.currentTarget.dataset.scrollable
    this.isScrollToTabs = e.currentTarget.dataset.scrollToTabs
    this.showTab()
  }

  showTab() {
    for (let index = 0; index < this.panelTargets.length; index++) {
      const panel = this.panelTargets[index]
      const tab = this.tabTargets[index]
      const dropdownItem = this.hasDropdownTarget ? this.dropdownItemTargets[index] : null

      if (index == this.index) {
        panel.classList.remove(this.hiddenClass)
        tab.classList.add(this.activeClass)

        if (this.isScrollable) {
          this.scrollIntoView(tab)
        }

        if (dropdownItem) {
          dropdownItem.classList.add(this.activeClass)
          this.dropdownSelectedTarget.textContent = dropdownItem.textContent
          if (this.dropdownTarget.dropdown) { this.dropdownTarget.dropdown.closeImmediately() }
        }

      } else {
        panel.classList.add(this.hiddenClass)
        tab.classList.remove(this.activeClass)
        if (dropdownItem) { dropdownItem.classList.remove(this.activeClass) }
      }
    }
    if (this.isScrollToTabs) {
      this.scrollToTopTabs()
    }
  }

  scrollIntoView(activeTab) {
    const container = activeTab.closest(".tabs-scroll-menu__list")
    if (container) {
      const containerWidth = container.offsetWidth
      const activeTabOffset = activeTab.offsetLeft
      const activeTabWidth = activeTab.offsetWidth
      const scrollTo = activeTabOffset - containerWidth / 2 + activeTabWidth / 2

      container.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      })
    }
  }

  scrollToTopTabs() {
    const header = document.getElementsByTagName('header')[0]
    const scrollMenu = this.element

    if (scrollMenu && header) {
      const headerHeight = header.clientHeight
      const scrollMenuRect = scrollMenu.getBoundingClientRect()

      if (scrollMenuRect.top - headerHeight < 0) {
        const scroll_y = scrollMenuRect.top - headerHeight - 24
        window.scrollBy({
          top: scroll_y,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  }
}
